import {createAction} from 'redux-actions';
import {apiGet, apiPost} from './api';

const actions = {
  //get data
  step_form_send_data: createAction('STEP_FORM_SEND_DATA'),
  step_form_initial_data_succeeded: createAction('STEP_FORM_INITIAL_DATA_SUCCEEDED'),
  step_form_failed: createAction('STEP_FORM_FAILED'),


  //step vrm
  vrm_search: createAction('STEP_VRM_SEARCH'),
  vrm_succeeded: createAction('STEP_VRM_SUCCEEDED'),
  vrm_failed: createAction('STEP_VRM_FAILED'),

  //step postcode
  postcode_search: createAction('STEP_POSTCODE_SEARCH'),
  postcode_succeeded: createAction('STEP_POSTCODE_SUCCEEDED'),
  postcode_failed: createAction('STEP_POSTCODE_FAILED'),

  //step form
  step_next_question_succeeded: createAction('STEP_NEXT_QUESTION_SUCCEEDED'),
  step_previous_question: createAction('STEP_PREVIOUS_QUESTION'),

  //reset
  step_reset: createAction('STEP_RESET'),

  step_update_schema_and_question: createAction('STEP_UPDATE_SCHEMA_AND_QUESTION'),

};

export default actions;

/********* STEP FROM *********/
    //sendData
const formSendData = (response, name) => {
      return {
        type: actions.step_form_send_data.toString(),
        name,
        payload: response,
      };
    };
const formInitialDattaSucceeded = (response, name) => {
  return {
    type: actions.step_form_initial_data_succeeded.toString(),
    name,
    payload: response,
  };

};
const formNextSucceeded = (response, name) => {
  return {
    type: actions.step_next_question_succeeded.toString(),
    name,
    payload: response,
  };
};
const formFailed = (response, name) => {
  return {
    type: actions.step_form_failed.toString(),
    name,
    payload: response,
  };
};

/********** VRM ************/
const vrmSearch = (response, name) => {
  return {
    type: actions.vrm_search.toString(),
    name,
    payload: response,
  };
};
const vrmSucceeded = (response, name) => {
  return {
    type: actions.vrm_succeeded.toString(),
    name,
    payload: response,
  };
};
const vrmFailed = (response, name) => {
  return {
    type: actions.vrm_failed.toString(),
    name,
    payload: response,
  };
};

/********** POSTCODE ************/
const postcodeSearch = (response, name) => {
  return {
    type: actions.postcode_search.toString(),
    name,
    payload: response,
  };
};
const postcodeSucceeded = (response, name) => {
  return {
    type: actions.postcode_succeeded.toString(),
    name,
    payload: response,
  };
};
const postcodeFailed = (response, name) => {
  return {
    type: actions.postcode_failed.toString(),
    name,
    payload: response,
  };
};

export const searchPostcode = (name, postcode) => {
  return apiGet('api/lookup/postcode',
      postcode,
      (res) => postcodeSearch(res, name),
      (res) => postcodeSucceeded(res, name),
      (res) => postcodeFailed(res, name));
};

export const searchVrm = (name, vrm) => {
  return apiGet('api/lookup/vrm',
      vrm,
      (res) => vrmSearch(res, name),
      (res) => vrmSucceeded(res, name),
      (data) => vrmFailed(data, name));
};

export const getInitialData = (name, uuid, defaultData={}) => {
  const path = name.replace('step_', '');
  return apiGet(`api/lead/${path.replace(/_/g,'-')}`, {uuid},
      (res) => formSendData(res, name),
      (res) => formInitialDattaSucceeded({...res, lead_details: {...defaultData, ...res.lead_details}}, name, ),
      (res) => formFailed(res, name));

};

export const getPrevious = (name, payload) => {
  return ({
    type: actions.step_previous_question.toString(),
    name,
    payload,
  });
};

export const getNext = (name, data) => {
  const path = name.replace('step_', '');
  return apiPost(`api/lead/${path.replace(/_/g,'-')}`, data,
      (res) => formSendData(res, name),
      (res) => formNextSucceeded(res, name),
      (res) => formFailed(res, name));
};

export const reset = (name) => {
  return {
    type: actions.step_reset.toString(),
    name,
  };
};

export const updateSchemaAndQuestion = (name,payload) => {
  return {
    type: actions.step_update_schema_and_question.toString(),
    name,
    payload,
  };
};

